import type { ErrorScope } from 'src/shared/constants/ErrorScope';
import { ErrorTagName } from 'src/shared/constants/ErrorTag';

import { useErrorTag } from '../useErrorTag';

const useErrorScope = (scope: ErrorScope) => {
  const tagName = ErrorTagName.SCOPE;

  useErrorTag(tagName, scope);
};

export { useErrorScope };
